import { Alert } from 'react-bootstrap';
import './ToastNotification.css';
import { useEffect } from 'react';

/**
 * Reusable toast notification for success/error messages.
 * Uses Bootstrap Alert variants (success/danger) for colours; no inline styles.
 * Auto-dismisses after autoDismissMs.
 *
 * @param {boolean} show - Whether the toast is visible
 * @param {() => void} onClose - Called when the toast auto-dismisses
 * @param {'success' | 'error'} type - Toast variant
 * @param {string} message - Body message
 * @param {number} [autoDismissMs=3000] - Auto-hide after this many ms; 0 = no auto-dismiss
 */
const ToastNotification = ({ show, onClose, type = 'success', message, autoDismissMs = 3000 }) => {
  useEffect(() => {
    if (!show || autoDismissMs <= 0) return;
    const timer = setTimeout(onClose, autoDismissMs);
    return () => clearTimeout(timer);
  }, [show, autoDismissMs, onClose]);

  if (!show) return null;

  const variant = type === 'error' ? 'danger' : 'success';
  const title = type === 'error' ? 'Error' : 'Success';

  return (
    <div className="toast-notification-container">
      <Alert variant={variant}>
        <div>
          <Alert.Heading>{title}</Alert.Heading>
          <p className="mb-0">{message}</p>
        </div>
      </Alert>
    </div>
  );
};

export default ToastNotification;
